<template>
  <div class="template-selector p-3 mb-3">
    <div class="current-template p-3 mb-3">
      <div
        class="site-selector mb-3 d-flex gap-2 align-items-center"
        data-v-539d2e29=""
      >
        <div class="me-2" data-v-539d2e29="">Website:</div>
        <div class="sites-scroll d-flex gap-2">
          <button
              v-for="site in sites"
              :key="site.id"
              @click="selectSite(site.id)"
              :class="['site-pill', { active: site.id === currentSiteId }]"
          >
            <img :src="site.favicon" alt="" class="site-fav" v-if="site.favicon" />
            <span class="site-name">{{ site.name }}</span>
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="mb-1">Current template: {{ currentTemplate?.theme?.name }}</h5>
          <small class="text-muted">version: {{ currentTemplate?.git_branch }}</small>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <div class="two-part-btn">
            <button class="main-btn" @click="mainAction">
              Manage template
            </button>
            <button class="icon-btn" @click="toggleDropdown">
              <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-compact-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 11l8 3l8 -3" /></svg>
            </button>

            <div v-if="dropdownOpen" class="version-dropdown">
              <div v-for="v in currentTemplate.versions" :key="v" class="version-item">
                <button class="btn btn-sm btn-link version-main" @click="customizeVersion(v.name)">
                  <span class="version-label col">{{ v.name }}</span>
                  <span class="version-actions col-auto">
                    <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg>
                  </span>
                </button>
                <button class="mobile-btn" title="Megnyitás mobilon (QR)" @click="openQr(v.name)">
                  <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-device-mobile"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z" /><path d="M11 4h2" /><path d="M12 17v.01" /></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="qr" class="qr-backdrop" @click.self="closeQr">
      <div class="qr-modal">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Megnyitás mobilon</h5>
          <button class="btn-close" @click="closeQr"></button>
        </div>
        <small class="text-muted d-block mb-3">{{ currentTemplate?.theme?.name }} · {{ qr.version }}</small>
        <img v-if="qr.image" :src="qr.image" alt="QR" class="qr-image" />
        <div class="qr-url mt-3">{{ qr.url }}</div>
        <div class="d-flex gap-2 mt-3">
          <button class="btn btn-sm btn-primary flex-grow-1" @click="copyQrUrl">{{ qr.copied ? "Másolva" : "Link másolása" }}</button>
        </div>
        <small class="text-muted d-block mt-2">Olvasd be a telefon kamerájával. A téma 60 percig marad beállítva a telefon böngészőjében.</small>
      </div>
    </div>

    <div class="installed-templates" v-if="templates?.length > 0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-2">Installed templates</h3>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-primary" @click="addNewTemplate">Add new template</button>
        </div>
      </div>
      <div class="templates-grid d-flex flex-wrap gap-3">
        <div v-for="t in otherTemplates" :key="t.id" class="template-card modern-card">
          <div class="template-thumbnail" v-if="t.theme.preview_image">
            <img :src="t.theme.preview_image" alt="preview" />
          </div>
          <div class="template-name text-center mt-1">{{ t?.theme?.name }}</div>
          <div class="template-actions d-flex justify-content-center gap-1 mt-2">
            <button class="btn btn-sm btn-secondary" @click="customizeTemplate(t)">Customize</button>
            <button class="btn btn-sm btn-info" @click="previewTemplate(t)">Preview</button>
            <button class="btn btn-sm btn-success" @click="setDefaultTemplate(t)">Set default</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../modules/http";
import QRCode from "qrcode";
export default {
  props: {
    sites: {
      type: Array,
      required: true,
    },
    templates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSiteId: 1,
      currentTemplateId: 1,
      dropdownOpen: false,
      qr: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  computed: {
    currentTemplate() {
      return this.templates?.find(t => t.id === this.currentTemplateId);
    },
    otherTemplates() {
      return this.templates?.filter(t => t.id !== this.currentTemplateId);
    },
    currentSite() {
      return this.sites.find(s => s.id === this.currentSiteId) || this.sites[0];
    },
  },
  watch: {
    sites(){
      this.currentSiteId = this.sites[0].id;
    },
    currentSiteId() {
      this.currentTemplateId = this.currentSite.webshop_template_id;
    },
  },
  methods: {
    updateTemplate(id) {
      http.fetch('/themes/template/'+id+'/update',{});
    },
    selectSite(id) {
      this.currentSiteId = id;
      this.dropdownOpen = false;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    changeVersion(version) {
      this.currentTemplate.version = version;
      this.dropdownOpen = false;
      alert(`Sablon verzió váltva: ${version}`);
    },
    mainAction() {
      window.open(`https://${this.currentSite.domain}${this.currentSite.slug.length > 0 ? "/"+this.currentSite.slug : ""}/set-template/${this.currentTemplate.preview_hash}`, '_blank').focus();
    },
    editPages() {
      alert(`Oldalak szerkesztése: ${this.currentTemplate.name}`);
    },
    addNewTemplate() {
      alert('Új sablon hozzáadása');
    },
    previewVersion(version) {
      alert(`Előnézet verzió: ${version}`);
    },
    versionUrl(version) {
      return `https://${this.currentSite.domain}${this.currentSite.slug.length > 0 ? "/"+this.currentSite.slug : ""}/set-template/${this.currentTemplate.preview_hash}/${version}`;
    },
    customizeVersion(version) {
      window.open(this.versionUrl(version), '_blank').focus();
    },
    async openQr(version) {
      const url = this.versionUrl(version);
      this.qr = { version, url, image: null, copied: false };
      const image = await QRCode.toDataURL(url, { width: 280, margin: 1 });
      if (this.qr?.url === url) this.qr.image = image;
    },
    closeQr() {
      this.qr = null;
    },
    onKeydown(e) {
      if (e.key === "Escape" && this.qr) this.closeQr();
    },
    async copyQrUrl() {
      await navigator.clipboard.writeText(this.qr.url);
      this.qr.copied = true;
    },
    customizeTemplate(t) {
      alert(`Személyre szabás: ${t.name}`);
    },
    previewTemplate(t) {
      alert(`Előnézet: ${t.name}`);
    },
    setDefaultTemplate(t) {
      this.currentTemplateId = t.id;
      alert(`Alapértelmezett sablon: ${t.name}`);
    },
  },
};
</script>

<style scoped>
.template-selector {
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(18, 18, 18, 0.03), 0 10px 30px rgba(18, 18, 18, 0.06);
}

.current-template {
  background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);
  border-radius: 14px 14px 0 0;
  margin: -1em -1em 3em -1em !important;
  color: #fff;
  overflow: visible;
}
.two-part-btn {
  position: relative;
  display: flex;
  border-radius: 99px;
  overflow: visible;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}
.two-part-btn .icon-btn {
  background: #fff;
  border: none;
  padding: 0.5rem 0.75rem;
  color: #000;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 0 99px 99px 0;
}
.main-btn {
  background: #fff;
  border: none;
  padding: 0.5rem 1.1rem;
  color: #000;
  flex-grow: 1;
  cursor: pointer;
  text-align: left;
  font-weight: 700;
  font-size: 13px;
  border-radius: 99px 0 0 99px;
}
.two-part-btn .icon-btn:hover, .main-btn:hover {
  opacity: 0.85;
}
.version-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  color: #000;
  border-radius: 0.5rem;
  width: max-content;
  min-width: 200px;
  margin-top: 0.25rem;
  z-index: 1050;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  padding: 0.5rem;
}
.version-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
  border-radius: 99px;
  transition: background .2s;
}
.version-item:not(:last-child) {
  margin-bottom: 0.25rem;
}
.version-item:hover {
  background: #f1f3f5;
}
.version-actions button {
  font-size: 0.75rem;
}
.version-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  text-align: left;
}
.btn.btn-link.version-main:hover,
.btn.btn-link.version-main:focus-within {
  background: transparent;
}
.mobile-btn {
  cursor: pointer;
  margin: 0;
  width: 32px;
  height: 32px;
  flex: none;
  padding: 0;
  display: grid;
  place-items: center;
  border: 1px solid #ced4da;
  border-radius: 50%;
  background: #fff;
  color: #333;
  transition: background .2s, border-color .2s;
}
.mobile-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}
.mobile-btn svg {
  width: 18px;
  height: 18px;
}
.qr-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(18, 18, 18, 0.45);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.qr-modal {
  background: #fff;
  border-radius: 14px;
  padding: 1.25rem;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 10px 30px rgba(18, 18, 18, 0.2);
  text-align: center;
}
.qr-modal h5 {
  text-align: left;
}
.qr-modal small {
  text-align: left;
}
.qr-image {
  width: 280px;
  max-width: 100%;
  height: auto;
}
.qr-url {
  font-size: 11px;
  word-break: break-all;
  color: #555;
  background: #f5f5f7;
  border-radius: 8px;
  padding: 0.5rem;
  text-align: left;
}
.installed-templates h6 {
  margin-bottom: 0.5rem;
}
.templates-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.template-card.modern-card {
  width: 320px;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  padding: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;
}
.template-card.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.template-thumbnail img {
  width: 100%;
  border-radius: 0.5rem;
}
.template-name {
  font-weight: 500;
  text-align: center;
  margin-top: 0.5rem;
}
.template-actions button {
  font-size: 0.75rem;
  flex: 1;
}
.site-selector { background: transparent; font-size: 13px; font-weight: 700; }
.sites-scroll { overflow-x: auto; padding-bottom: 4px; }
.site-pill { display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.35rem 0.9rem; border-radius: 999px; border: none; background: rgba(255,255,255,.2); color: #fff; cursor: pointer; font-size: 12px; font-weight: 700; transition: background .15s; }
.site-pill:hover { background: rgba(255,255,255,.35); }
.site-pill.active { background: #fff; color: #121212; }
.site-fav { width: 18px; height: 18px; border-radius: 3px; object-fit: cover; }
</style>
